import React from "react";

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import { Toaster } from "sonner";

import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import LoadingSplash from "@/components/LoadingSplash";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import CareersPage from "@/pages/CareersPage";
import ContactPage from "@/pages/ContactPage";

function App() {

  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {

    const t = setTimeout(() => setLoading(false), 1400);

    return () => clearTimeout(t);

  }, []);

  return (

    <div className="App">

      {loading && <LoadingSplash />}

      <BrowserRouter>

        {/* AUTO SCROLL TO TOP ON PAGE CHANGE */}

        <ScrollToTop />

        <ScrollProgress />

        <Navbar />

        <main>

          <Routes>

            <Route
              path="/"
              element={<HomePage />}
            />

            <Route
              path="/about"
              element={<AboutPage />}
            />

            <Route
              path="/services"
              element={<ServicesPage />}
            />

            <Route
              path="/services/:slug"
              element={<ServiceDetailPage />}
            />

            <Route
              path="/careers"
              element={<CareersPage />}
            />

            <Route
              path="/contact"
              element={<ContactPage />}
            />

          </Routes>

        </main>

        <Footer />

        <FloatingWhatsApp />

      </BrowserRouter>

      <Toaster
        theme="light"
        position="bottom-right"
        richColors
      />

    </div>
  );
}

export default App;